import React from "react";
import animationData from "./Loader.json";
import Lottie from "react-lottie";
import './Loader.css';

const LoaderTeacher = ({loader_text}) => {
    const defaultOptions = {
			loop: true,
			autoplay: true,
			animationData: animationData,
		};
    return (
			<div className="loader-teacher">
				<Lottie
					isClickToPauseDisabled={true}
					className="loader-image"
					options={defaultOptions}
				/>
				<center><div className="loader-text">{loader_text}...</div></center>
			</div>
		);
}

export default LoaderTeacher;